// jquery functions for checkout sidebar floating functionality

export function headerSticky() {
    // check if header container exists before executing
    if (jQuery('#header-container').length > 0) {
        var navbar = document.getElementById("header-container");
        var sticky = navbar.offsetHeight;
        var fixedElement = document.querySelector('.outer-wrap');

        // Get the scroll position of the fixed element
        var scroll = Math.abs(fixedElement.offsetTop - window.scrollY);
        var windowWidth = window.innerWidth;

        if (windowWidth >= 768) {
            jQuery("body").removeClass("is-mobile");
            jQuery(".logo-desktop").show();
            jQuery(".scroll-search-container").hide();
            jQuery(".login-icon-wrapper").append(jQuery(".login.account"));
            // jQuery(".login.account").append(jQuery(".pulldown"));
            // jQuery(".modal-mobile-signin").hide();
            // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
            if (scroll > sticky) {
            jQuery("#header-container").addClass("sticky");
            jQuery(".logo-scroll").show();
            jQuery(".logo-desktop").hide();
            jQuery("#topnav")
                .parent()
                .addClass("flex-row-reverse");
            jQuery(".scroll-search-button")
                .removeClass("scroll-search-button-mobile")
                .show()
                .appendTo("#topnav");
            //hide algolia search box if someone scrolls or screen is resized
            jQuery("#algolia-autocomplete-container .aa-dropdown-menu").hide();
            } else {
            jQuery("#header-container").removeClass("sticky");
            jQuery(".logo-scroll").hide();
            jQuery(".scroll-search-button").hide();
            jQuery(".scroll-search-container").removeClass('d-lg-block');
            jQuery(".logo-desktop").show();
            jQuery("#topnav")
                .parent()
                .removeClass("flex-row-reverse");
            }
        } else {
            jQuery("body").addClass("is-mobile");
            jQuery(".logo-scroll").hide();
            jQuery(".logo-desktop").hide();
            jQuery(".mobilemainheader-list").prepend(jQuery(".login.account"));
            jQuery("#topnav")
            .parent()
            .removeClass("flex-row-reverse");
            jQuery(".scroll-search-button")
            // .show()
            .addClass("scroll-search-button-mobile");
            jQuery(".scroll-search-container").show();
            jQuery(".login-icon-wrapper").append(jQuery(".scroll-search-button-mobile"));
            if (scroll > sticky) {
            jQuery("#header-container").addClass("sticky");
            jQuery("#algolia-autocomplete-container .aa-dropdown-menu").css(
                "z-index",
                "5"
            );
            } else {
            jQuery("#header-container").removeClass("sticky");
            }
        }
    }
}